var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:"input",attrs:{"type":"tel","autocomplete":"off"},domProps:{"value":_vm.formattedValue},on:{"keydown":_vm.handleKeydown,"input":_vm.updateValue,"mousedown":_vm.preventClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }